import type {
  WidgetConfigBase,
  WidgetId,
  WidgetSettings,
  WidgetType,
} from '../widgetRegistry';

export const extractWidgetDefaults = <T extends WidgetConfigBase>(
  config: T,
) => {
  const defaults: Partial<WidgetSettings<T>> = {};
  for (const key in config) {
    if (config[key] === undefined) {
      continue;
    }
    const defaultValue = config[key].defaultValue;
    defaults[key] = defaultValue as WidgetSettings<T>[Extract<keyof T, string>];
  }
  return defaults;
};

// Utility to generate unique widget IDs
export const generateWidgetId = (widgetType: WidgetType): WidgetId =>
  `${widgetType}-${Date.now()}-${Math.random().toString(36).substring(2, 9)}`;
